import _mergeWithKey from "ramda/es/mergeWithKey";
import _reduceBy from "ramda/es/reduceBy";
import _values from "ramda/es/values";
import _pipe from "ramda/es/pipe";
import _curry from "ramda/es/curry";
export default _curry(function (keyFn, mergeFn, list) {
  return _pipe(_reduceBy(_mergeWithKey(mergeFn), {}, keyFn), _values)(list);
});